import React, { useEffect, useState } from 'react';
import { alpha, styled } from '@mui/material/styles';
import { Typography, CardMedia, CardActions, CardContent, Button, Card, Box } from '@mui/material';
import PropTypes from 'prop-types';
import axios from 'axios';

import SERVER_API_URL from '../../../config'

const LIGHT_GRAY = '#f7f7f7';
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '' : LIGHT_GRAY,
}));

export default function ChurchCard({ church, handleDialog, twoLineNoWrapStyle }) {

  const [avatar, setAvatar] = useState({});

  useEffect(() => {
    const getAvatarById = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/getChurchAvatar/getAvatarById/${church && church.id}`, {
          responseType: 'blob',
        });
        if (response.status === 200) {
          setAvatar(URL.createObjectURL(response.data));
        }
        throw new Error('Failed to fetch avatar');
      } catch (e) {
        console.error('Error fetching avatar:', e);
        // throw e;
      }
    }
    getAvatarById();

  }, [church]);
 
  return (
    <StyledCard
      sx={{
        boxShadow: (theme)=> `
        -8px -8px 10px ${alpha(theme.palette.primary.darker, 0.05)},
        8px 8px 5px ${alpha(theme.palette.primary.darker, 0.025)}
      `,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.05)',
          cursor: 'pointer',
        },
      }}
      onClick={() => handleDialog(church && church.id)}
    >
      {avatar && (
        <CardMedia
          component="div"
          sx={{
            // 16:9
            pt: '56.25%',
          }}
          image={avatar}
        />
      )}
      {!avatar && (
        <CardMedia
          component="div"
          sx={{
            // 16:9
            pt: '56.25%',
          }}
          image="/assets/landing/empty_church.png"
        />
      )}
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="h2">
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography gutterBottom variant="h5" component="h2">
              {church.name}
            </Typography>
            <Typography sx={{ minWidth: 100 }} gutterBottom variant="body1" color="darkgray">
              {church.type}
            </Typography>
          </Box>
        </Typography>
        <Typography style={twoLineNoWrapStyle}>{church.description} </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'right' }}>
        <Button size="small" color="info" onClick={() => handleDialog(church.id)}>
          ስለ አጥቢያው
        </Button>
      </CardActions>
    </StyledCard>
  );
}

ChurchCard.propTypes = {
  church: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  handleDialog: PropTypes.func.isRequired,
  twoLineNoWrapStyle: PropTypes.func.isRequired,
};
